import classNames from "classnames";
import React from "react";
import { getId } from "./utils";
import { PhosphorLink } from "components/Atoms/PhosphorIcon";

interface Props {
  appointment: server.dto.PlannerAppointment
  linkedFlightSegmentIds: number[]
  linkedGroundTransportIds: number[]
  linkedTrainSegmentIds: number[]
  onToggleLinked: () => void
}

const LinkAppointment = (props: Props) => {
  const allLinkedIds = [...props.linkedFlightSegmentIds, ...props.linkedGroundTransportIds, ...props.linkedTrainSegmentIds];
  const appointmentId = +getId(props.appointment);
  const isLinked = allLinkedIds.includes(appointmentId);

  const [isHovering, setIsHovering] = React.useState(false);

  const classes = classNames("", {
    "green-bg": isLinked && !isHovering,
    "red-bg": isLinked && isHovering,
    "white-text": isLinked,
    "gray-250": !isLinked,
    hoverable: !isLinked
  });

  return <td
    className={classes}
    style={{ width: 30, cursor: "pointer", textAlign: "center" }}
    onClick={props.onToggleLinked}
    onMouseEnter={() => { setIsHovering(true); }}
    onMouseLeave={() => { setIsHovering(false); }}
  >
    <div className="padding-small">
      <PhosphorLink />
    </div>
  </td>;
};

export default LinkAppointment;